import Vue from "vue";
import Vuex from "vuex";
import baseAPI from "@/http";
import { userAPI } from "@/modules/user/components/UserAPI";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isAdmin: false,
    isFullAdmin: false,
    isIndicadores: false,
    isNA: false,
    isConsultor: false,
    isAnalista: false,
    isAD: false,
    isConsultorCondutorMunicipio: false,
    isConsultorEspecialistaMunicipio: false,
    isAnalistaMunicipio: false,
    isADMunicipio: false,
    isSPFesp: false,
    isSPFespEspecial: false,
    isSPCoordenador: false,
    loading: false,
    token: null,
    user: null,
    config: {},
    groupsConfig: {},
    uf: process.env.VUE_APP_ESTADO,
    logo: process.env.VUE_APP_LOGO,
    logos: {
      logo_azul: "",
      logo_preta: "",
      logo_branca: "",
      logo_encurtada_azul: "",
      logo_encurtada_preta: "",
      logo_encurtada_branca: "",
      login: "",
      tema: "preta",
    },
    title: "",
    forcedLogout: false,
    city: null,
    cityId: null,
    isSala: false,
    isAT: false,
    isTerritorio: false,
    isGov: true,
    isCE: true,
    isTur: true,
    isParceiro: false,
    urlTag: "",
    /** Reload das opções do termo de referencia */
    //#region Termo de referencia
    reloadTR: {
      groups: false,
      tasks: false,
      solutions: false,
      evidences: false,
    },
    filterTR: {
      groups: {},
      tasks: {},
      solutions: {},
    },
    //#endregion
  },
  mutations: {
    SET_USER(state, payload) {
      Vue.set(state, "user", payload);
      state.user = payload;
      if (!!payload) {
        Vue.set(state, "isAuthenticated", true);
        state.isAdmin = payload.grupo
          ? payload.grupo.nome == "Administrador"
          : false;
      } else {
        Vue.set(state, "isAuthenticated", false);
      }

      localStorage.setItem("user", JSON.stringify(payload));
    },
    SET_CONFIG(state, payload) {
      Vue.set(state, "config", payload);
      localStorage.setItem("config", JSON.stringify(payload));
    },
    SET_LOGOS(state, payload) {
      Vue.set(state, "logos", payload);
    },
    SET_GROUPS_CONFIG(state, payload) {
      Vue.set(state, "groupsConfig", payload);
      localStorage.setItem("groupsConfig", JSON.stringify(payload));
    },
    SET_UF(state, payload) {
      state.uf = payload;
      localStorage.setItem("uf", payload);
    },
    SET_ISSALA(state, payload) {
      state.isSala = payload;
      localStorage.setItem("isSala", payload);
    },
    SET_ISCE(state, payload) {
      state.isCE = window.location.href.includes("cidadeempreendedora");
      localStorage.setItem("isCE", payload);
    },
    SET_ISDT(state, payload) {
      state.isDT = window.location.href.includes("desenvolvimentoterritorial");
      localStorage.setItem("isDT", payload);
    },
    SET_ISAT(state, payload) {
      state.isAT = payload;
      localStorage.setItem("isAT", payload);
    },
    SET_ISGOV(state, payload) {
      state.isGov = payload;
      localStorage.setItem("isGov", payload);
    },
    SET_ISTUR(state, payload) {
      state.isTur = payload;
      localStorage.setItem("isTur", payload);
    },
    SET_ISPARCEIRO(state, payload) {
      state.isParceiro = payload;
      localStorage.setItem("isParceiro", payload);
    },
    SET_LOGO(state, payload) {
      state.logo = payload;
      localStorage.setItem("logo", payload);
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
      state.isAuthenticated = true;
      localStorage.setItem("token", payload);
    },
    LOGOUT: (state) => {
      state.isAuthenticated = false;

      delete state.token;
      localStorage.removeItem("token");

      delete state.user;
      localStorage.removeItem("user");
      localStorage.removeItem("groupsConfig");
      localStorage.removeItem("config");
      state.isAdmin = false;
      state.isFullAdmin = false;
      state.isConsultor = false;
      state.isAnalista = false;
      state.isAD = false;

      delete baseAPI.defaults.headers.common["Authorization"];
    },
    SET_ADMIN(state, payload) {
      state.isAdmin = payload;
    },
    SET_FULLADMIN(state, payload) {
      state.isFullAdmin = payload;
    },
    SET_INDICADORES(state, payload) {
      state.isIndicadores = payload;
    },
    SET_NA(state, payload) {
      state.isNA = payload;
    },
    SET_URL_TAG(state, payload) {
      state.urlTag = payload;
    },
    SET_SP_FESP(state, payload) {
      state.isSPFesp = payload;
    },
    SET_SP_FESP_ESPECIAL(state, payload) {
      state.isSPFespEspecial = payload;
    },
    SET_SP_COORDENADOR(state, payload) {
      state.isSPCoordenador = payload;
    },
    SET_CONSULTOR(state, payload) {
      state.isConsultor = payload;
    },
    SET_ANALISTA(state, payload) {
      state.isAnalista = payload;
    },
    SET_AD(state, payload) {
      state.isAD = payload;
    },
    SET_CONSULTOR_CONDUTOR_MUNICIPIO(state, idMunicipio) {
      if (state.isAuthenticated === true) {
        let usuarioLocal = JSON.parse(localStorage.getItem("user"));
        userAPI.findUser(usuarioLocal.usuarioId).then(({ data: usuario }) => {
          for (let count = 0; count < usuario.permissoes.length; count++) {
            if (
              usuario.permissoes[count].municipioId === parseInt(idMunicipio) &&
              usuario.permissoes[count].permissao.nome === "Consultor Condutor"
            ) {
              state.isConsultorCondutorMunicipio = true;
              break;
            } else {
              state.isConsultorCondutorMunicipio = false;
            }
          }

          for (
            let count = 0;
            count < usuario.permissoesSolucoes.length;
            count++
          ) {
            if (
              usuario.permissoesSolucoes[count].municipioId ===
              parseInt(idMunicipio)
            ) {
              state.isConsultorCondutorMunicipio = true;
              break;
            } else {
              state.isConsultorCondutorMunicipio = false;
            }
          }
        });
      } else {
        state.isConsultorCondutorMunicipio = false;
      }
    },
    async SET_CONSULTOR_ESPECIALISTA_MUNICIPIO(state, idMunicipio) {
      if (state.isAuthenticated === true) {
        let usuarioLocal = JSON.parse(localStorage.getItem("user"));
        await userAPI
          .findUser(usuarioLocal.usuarioId)
          .then(({ data: usuario }) => {
            for (let count = 0; count < usuario.permissoes.length; count++) {
              if (
                usuario.permissoes[count].municipioId ===
                  parseInt(idMunicipio) &&
                usuario.permissoes[count].permissao.nome ===
                  "Consultor Especialista"
              ) {
                state.isConsultorEspecialistaMunicipio = true;
                break;
              } else {
                state.isConsultorEspecialistaMunicipio = false;
              }
            }
          });
      } else {
        state.isConsultorEspecialistaMunicipio = false;
      }
    },
    async SET_ANALISTA_MUNICIPIO(state, idMunicipio) {
      if (state.isAuthenticated === true) {
        let usuarioLocal = JSON.parse(localStorage.getItem("user"));
        await userAPI
          .findUser(usuarioLocal.usuarioId)
          .then(({ data: usuario }) => {
            for (let count = 0; count < usuario.permissoes.length; count++) {
              if (
                usuario.permissoes[count].municipioId ===
                  parseInt(idMunicipio) &&
                usuario.permissoes[count].permissao.nome === "Analista"
              ) {
                state.isAnalistaMunicipio = true;
                break;
              } else {
                state.isAnalistaMunicipio = false;
              }
            }
          });
      } else {
        state.isAnalistaMunicipio = false;
      }
    },
    async SET_AD_MUNICIPIO(state, idMunicipio) {
      if (state.isAuthenticated === true) {
        let usuarioLocal = JSON.parse(localStorage.getItem("user"));
        userAPI.findUser(usuarioLocal.usuarioId).then(({ data: usuario }) => {
          for (let count = 0; count < usuario.permissoes.length; count++) {
            if (
              usuario.permissoes[count].municipioId === parseInt(idMunicipio) &&
              usuario.permissoes[count].permissao.nome === "AD"
            ) {
              state.isADMunicipio = true;
              break;
            } else {
              state.isADMunicipio = false;
            }
          }
        });
      } else {
        state.isADMunicipio = false;
      }
    },
    SET_FORCED_LOGOUT(state, payload) {
      localStorage.setItem("forcedLogout", payload);
      state.forcedLogout = payload;
    },
    SET_CITY_NAME(state, payload) {
      localStorage.setItem("city", payload);
      state.city = payload;
    },
    SET_CITY_ID(state, payload) {
      localStorage.setItem("cityId", payload);
      state.cityId = payload;
    },
    //#region Termo de referencia
    RELOAD_ALL(state) {
      state.reloadTR.groups = !state.reloadTR.groups;
      state.reloadTR.tasks = !state.reloadTR.tasks;
      state.reloadTR.solutions = !state.reloadTR.solutions;
    },
    RESETE_ALL(state) {
      state.reloadTR.groups = false;
      state.reloadTR.tasks = false;
      state.reloadTR.solutions = false;
      state.reloadTR.evidences = false;
    },
    RELOAD(state, payload) {
      payload.forEach((element) => {
        state.reloadTR[element] = !state.reloadTR[element];
      });
    },
    RESETE(state, payload) {
      payload.forEach((element) => {
        state.reloadTR[element] = false;
      });
    },
    SET_FILTER_TR(state, payload) {
      payload.forEach((element) => {
        state.filterTR[element] = false;
      });
    },
    SET_CONFIGGLOBAL(state, payload) {
      state.isAuthenticated = !!localStorage.getItem("token");
      state.urlTag = payload.urlTag;
      state.uf = payload.uf;
      state.na = payload.na;
      state.logo = payload.logo;
      state.isSala = payload.isSala;
      state.isCE =
        window.location.href.includes("cidadeempreendedora") || payload.isCE;
      state.isDT =
        window.location.href.includes("desenvolvimentoterritorial") ||
        payload.isDT;
      state.isAT = payload.isAT;
      state.isGov = payload.isGov;
      state.isTur = payload.isTur;
      state.isIndicadores = payload.isIndicadores;
      state.isParceiro = payload.isParceiro;
      state.isTerritorio = payload.isTerritorio;
      Vue.set(state, "title", payload.title);
    },
    //#endregion
  },
  actions: {
    renewUser({ commit, state }) {
      var user = state.user;
      userAPI.get(user.usuarioId).then(({ data }) => {
        var user = data;

        if (user.email === "admin@admin.com.br") {
          user.grupo.verTodosEixos = true;
          user.grupo.visualizaMunicipio = true;
        }

        commit("SET_USER", user);
      });
    },
    setLoading({ commit }, payload) {
      commit("SET_LOADING", payload);
    },
    setLogos({ commit }, payload) {
      commit("SET_LOGOS", payload);
    },
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },
    setUser({ commit }, payload) {
      var user = payload;

      if (user && user.email === "admin@admin.com.br") {
        user.grupo.verTodosEixos = true;
        user.grupo.visualizaMunicipio = true;
      }

      commit("SET_USER", user);
    },
    setConfig({ commit }, payload) {
      commit("SET_CONFIG", payload);
    },
    setIsDT({ commit }, payload) {
      commit("SET_ISDT", payload);
    },
    setGroupsConfig({ commit }, payload) {
      commit("SET_GROUPS_CONFIG", payload);
    },
    setSPFesp({ commit }, payload) {
      commit("SET_SP_FESP", payload);
    },
    setSPFespEspecial({ commit }, payload) {
      commit("SET_SP_FESP_ESPECIAL", payload);
    },
    setSPCoordenador({ commit }, payload) {
      commit("SET_SP_COORDENADOR", payload);
    },

    setConfigsGlobal({ commit, dispatch }, payload) {
      commit("SET_CONFIGGLOBAL", payload);
      dispatch("setUser", payload.user);
      dispatch("setConfig", payload.config);
      dispatch("setGroupsConfig", payload.groupsConfig);
      dispatch("setLogos", payload.logos);
    },

    setFullAdmin({ commit }, payload) {
      commit("SET_FULLADMIN", payload);
    },

    setConsultor({ commit }, payload) {
      commit("SET_CONSULTOR", payload);
    },
    setAnalista({ commit }, payload) {
      commit("SET_ANALISTA", payload);
    },
    setAD({ commit }, payload) {
      commit("SET_AD", payload);
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
    setConsultorCondutorMunicipio({ commit }, idMunicipio) {
      commit("SET_CONSULTOR_CONDUTOR_MUNICIPIO", idMunicipio);
    },
    setConsultorEspecialistaMunicipio({ commit }, idMunicipio) {
      commit("SET_CONSULTOR_ESPECIALISTA_MUNICIPIO", idMunicipio);
    },
    setAnalistaMunicipio({ commit }, idMunicipio) {
      commit("SET_ANALISTA_MUNICIPIO", idMunicipio);
    },
    setADMunicipio({ commit }, idMunicipio) {
      commit("SET_AD_MUNICIPIO", idMunicipio);
    },
    setForcedLogout({ commit }, payload) {
      commit("SET_FORCED_LOGOUT", payload);
    },
    setCityName({ commit }, payload) {
      commit("SET_CITY_NAME", payload);
    },
    setCityId({ commit }, payload) {
      commit("SET_CITY_ID", payload);
    },
    //#region Termo de referencia
    reloadAllValues({ commit }) {
      commit("RELOAD_ALL");
    },
    reseteAllValues({ commit }) {
      commit("RESETE_ALL");
    },
    reload({ commit }, payload) {
      commit("RELOAD", payload);
    },
    resete({ commit }, payload) {
      commit("RESETE", payload);
    },

    setFilterTR({ commit }, payload) {
      commit("SET_FILTER_TR", payload);
    },

    //#endregion
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    isLoading: (state) => state.loading,
    logos: (state) => {
      const logos = {
        logo: state.logos[`logo_${state.logos.tema}`],
        logoEncurtada: state.logos[`logo_encurtada_${state.logos.tema}`],
        login: state.logos[`login_${state.logos.tema}`],
        logoBranca: state.logos[`logo_branca`],
        logoConstrate: state.logos[`logo_${state.logos.temaConstrate}`],
      };
      return logos;
    },
    isTerritorio: (state) => state.isTerritorio,
    isAdmin: (state) => state.isAdmin,
    isDT: (state) => state.isDT,
    isFullAdmin: (state) => state.isFullAdmin,
    isIndicadores: (state) => state.isIndicadores,
    isNA: (state) => state.isNA,
    isConsultor: (state) => state.isConsultor,
    isAnalista: (state) => state.isAnalista,
    isSPFesp: (state) => state.isSPFesp,
    isSPFespEspecial: (state) => state.isSPFespEspecial,
    isSPCoordenador: (state) => state.isSPCoordenador,
    isAD: (state) => state.isAD,
    isConsultorCondutorMunicipio: (state) => state.isConsultorCondutorMunicipio,
    isConsultorEspecialistaMunicipio: (state) =>
      state.isConsultorEspecialistaMunicipio,
    isAnalistaMunicipio: (state) => state.isAnalistaMunicipio,
    isADMunicipio: (state) => state.isADMunicipio,
    loading: (state) => state.loading,
    token: (state) => state.token,
    user: (state) => state.user,
    config: (state) => state.config,
    groupsConfig: (state) => state.groupsConfig,
    uf: (state) => state.uf,
    urlTag: (state) => state.urlTag,
    logo: (state) => state.logo,
    forcedLogout: (state) => state.forcedLogout,
    city: (state) => state.city,
    title: (state) => state.title,
    cityId: (state) => state.cityId,
    isAT: (state) => state.isAT,
    isGov: (state) => state.isGov,
    isTur: (state) => state.isTur,
    isCE: (state) => state.isCE,
    isSala: (state) => state.isSala,
    isParceiro: (state) => state.isParceiro,
    //#region Termo de referencia
    /** reload group in term reference */
    reloadTRGroup: (state) => state.reloadTR.groups,
    /** reload taska in term reference */
    reloadTRTask: (state) => state.reloadTR.tasks,
    /** reload solutions in term reference */
    reloadTRSolutions: (state) => state.reloadTR.solutions,
    /** reload evidences in term reference */
    reloadTREvidences: (state) => state.reloadTR.evidences,

    filterTRGroup: (state) => state.filterTR.groups,
    /** filter taska in term reference */
    filterTRTask: (state) => state.filterTR.tasks,
    /** filter solutions in term reference */
    filterTRSolutions: (state) => state.filterTR.solutions,
    /** filter evidences in term reference */
    //#endregion
  },
});
